module.exports = __webpack_public_path__ + "img/11.Kawasaki2020.23c4d07b.png";